/* eslint-disable */
<template>
  <div class="profile-container">
    <div class="profile-overview">
      <!-- LOADER -->
      <div v-if="loading" class="loading-screen">
        <div>
          <Loader />
        </div>
      </div>
      <div class="profile-header">
        <h2>Profile Overview</h2>

        <div class="header-btn flex">
          <button class="btn-secondary disabled">Share</button>
          <button class="btn">
            <router-link to="vendors/edit-vendor-profile" style="color: #fff">
              Edit profile
            </router-link>
          </button>
        </div>
      </div>

      <!-- STATS -->
      <div class="stats">
        <div class="main-stats">
          <h4>Total earnings</h4>
          <div>₦ {{ formattedTotalEarnings }}</div>
        </div>

        <div>
          <div class="main-stats">
            <h4>Impressions</h4>
            <div>{{ impressions }}</div>
          </div>
        </div>
      </div>

      <!-- TABS -->
      <div class="appointments-container">
        <TabComponent />
      </div>
    </div>

    <div class="plumber-profile-card">
      <div class="plumber-profile-card__content">
        <!-- <img :src="profile.image" alt="Profile" class="plumber-profile-card__image" /> -->
        <!-- <div v-if="profile.image">
          <img :src='profile.image' alt="" class="plumber-profile-card__image"/>

       </div> -->
        <img
          src="@/assets/profileImage.jpg"
          alt=""
          class="plumber-profile-card__image"
        />

        <div></div>

        <h2 class="plumber-profile-card__name">
          <span> {{ profile.firstname }} {{ profile.lastname }}</span>
          <span v-if="profile.isOnline" class="plumber-profile-card__status-dot"
            >•</span
          >
        </h2>
        <p
          class="plumber-profile-card__title"
          v-if="profile.profession || profile.location"
        >
          {{ profile.profession }} • {{ profile.location }}
        </p>

        <div class="plumber-profile-card__toggle">
          <label class="plumber-profile-card__switch">
            <input
              type="checkbox"
              v-model="isOnline"
              :class="isOnline ? 'online' : 'offline'"
              false-value="offline"
              true-value="online"
              :disabled="loading"
              @change="toggleOnlineStatus"
            />
            <span class="plumber-profile-card__slider"></span>
          </label>
          <span class="plumber-profile-card__toggle-label">{{
            isOnline ? "Go Offline" : "Go Online"
          }}</span>
        </div>

        <div class="plumber-profile-card__stats">
          <div class="plumber-profile-card__stat-item">
            <p class="plumber-profile-card__value">{{ profile.jobs }}</p>
            <p class="plumber-profile-card__label">Jobs</p>
          </div>
          <!-- <div class="plumber-profile-card__stat-item">
          <p class="plumber-profile-card__value">{{ profile.responseRate }}</p>
          <p class="plumber-profile-card__label">Response rate</p>
        </div> -->
          <div class="plumber-profile-card__stat-item">
            <div class="plumber-profile-card__star">
              <span class="plumber-profile-card__star-icon"
                ><svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.65327 2.33781L10.8266 4.68448C10.9866 5.01115 11.4133 5.32448 11.7733 5.38448L13.8999 5.73781C15.2599 5.96448 15.5799 6.95115 14.5999 7.92448L12.9466 9.57781C12.6666 9.85781 12.5133 10.3978 12.5999 10.7845L13.0733 12.8311C13.4466 14.4511 12.5866 15.0778 11.1533 14.2311L9.15994 13.0511C8.79994 12.8378 8.20661 12.8378 7.83994 13.0511L5.84661 14.2311C4.41994 15.0778 3.55327 14.4445 3.92661 12.8311L4.39994 10.7845C4.48661 10.3978 4.33327 9.85781 4.05327 9.57781L2.39994 7.92448C1.42661 6.95115 1.73994 5.96448 3.09994 5.73781L5.22661 5.38448C5.57994 5.32448 6.00661 5.01115 6.16661 4.68448L7.33994 2.33781C7.97994 1.06448 9.01994 1.06448 9.65327 2.33781Z"
                    fill="#FEC84B"
                  />
                </svg>
              </span>
              <p class="plumber-profile-card__value">{{ profile.stars }}</p>
            </div>
            <p class="plumber-profile-card__label">Stars</p>
          </div>
        </div>
      </div>

      <!-- Calendar Section -->
      <div class="calendar-section">
        <AgentProfileCalendar />
      </div>

      <!-- REVIEWS CHART -->

      <div class="chart-container">
        <h2 class="title">Customer's Satisfaction</h2>
        <div class="chart-wrapper d-none">
          <ReviewChart />
        </div>
        <div>
          <EmptyState :emptyData="emptyDataObject" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabComponent from "../smartVendors/VendorsProfileTabs.vue";
import AgentProfileCalendar from "../smartVendors/VendorProfileCalendar.vue";
import ReviewChart from "../smartVendors/VendorsReviewChart.vue";
import setVendorProfile from "../services/vendorprofile";
import Loader from "../components/Loader.vue";
import EmptyState from "../components/EmptyState.vue";

export default {
  components: {
    TabComponent,
    AgentProfileCalendar,
    ReviewChart,
    Loader,
    EmptyState,
  },
  data() {
    return {
      loading: false,
      vendorsOnlineStatus: "",
      showRescheduleModal: false,
      user: "",
      impressions: "",
      totalEarnings: "",
      totalRequest: "",
      totalReschedule: "",
      appointments: {},
      emptyDataObject: {
        header: "No record yet",
        option: "No customer's review yet",
      },

      isOnline: false,
      uploads: [],
      profile: {
        firstname: "",
        lastname: "",
        profession: "",
        location: "",
        image: "",
        jobs: "",
        // responseRate: 0,
        stars: "",
      },
    };
  },
  mounted() {
    this.getVendorsProfile();
  },
  methods: {
    formatNumberWithCommas(number) {
      if (number == null || isNaN(number)) return "0";
      return Number(number).toLocaleString();
    },

    async toggleOnlineStatus() {
      this.loading = true;
      try {
        let activeStatus = null;
        this.isOnline ? activeStatus == "online" : activeStatus == "offline";

        let payload = {
          online_status: this.isOnline,
        };
        // Save to localStorage
        // localStorage.setItem("onlineStatus", JSON.stringify(this.isOnline));
        await setVendorProfile
          .toggleOnlineStatus(JSON.stringify(payload))
          .then((res) => {
            if (res.success) {
              this.getVendorsProfile();
              console.log("Data sent");
            } else {
              this.$toast.error("Something went wrong, please try again");
            }
          })
          .catch((error) => {
            console.log("Error", error);
          });
      } finally {
        this.loading = false;
      }
    },

    async getVendorsProfile() {
      this.loading = true;

      let userID = this.$store.getters.getUser.id;

      await setVendorProfile
        .vendorProfileOverview(userID)
        .then((data) => {
          console.log("vendor", data)
          this.totalEarnings = data.earnings;
          this.impressions = data.impressions;
          this.profile.firstname = data.user.firstname;
          this.profile.lastname = data.user.lastname;
          this.profile.image = data.user.meansofidfile;
          this.profile.jobs = data.jobs;
          this.profile.stars = data.ratings;
          this.profile.profession = data.user.realtoroccupation;
          this.vendorsOnlineStatus = data.main_data.online_status;

          this.isOnline = this.vendorsOnlineStatus;
        })
        .catch((error) => {
          console.log("Error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    formattedTotalEarnings() {
      return this.formatNumberWithCommas(this.totalEarnings);
    },
  },

  created() {
    // const savedStatus = localStorage.getItem("onlineStatus");
    // if (vendorsOnlineStatus !== null) {
    //   this.isOnline = this.vendorsOnlineStatus;
    // }
    // Make initial API call with the status
    // this.toggleOnlineStatus();
  },
};
</script>

<style scoped>
/* EVERYTHING IN THIS COMPONENT SHOULD USE THE LATO FONT */
* {
  font-family: "Lato", sans-serif;
}

/* REUSEABLE CLASSES FOR THIS COMPONENT*/
.cursor-pointer {
  cursor: pointer;
}

.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.no-bg {
  background: none !important;
}
.font-400 {
  font-weight: 400;
  font-size: 14px;
  color: #555c74;
}
.font-600 {
  font-weight: 600;
  font-size: 16px;
}
.flex {
  display: flex;
  align-items: center;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.space-between {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.text-blue {
  color: #0033ea;
}

.btn-secondary {
  background-color: rgb(229, 229, 229);
  border-color: #d5d7da;
  color: #374151;
  border-radius: 8px;
  border: 1px solid hsla(216, 6%, 85%, 1);
  padding: 8px 18px;
  cursor: not-allowed;
}

/* ================ MAIN STYLES ===============*/
.profile-container {
  padding: 0 20px;
  background: #fff;
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 20px;
  min-height: 100vh;
}

.profile-container .profile-overview {
  width: 65%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.profile-container .profile-info-container {
  padding: 32px 24px;
  border-radius: 8px;
  line-height: 25px;
}

.header-btn {
  gap: 20px;
}

.profile-container .profile-info-container .profile-info {
  display: flex;
  gap: 12px;
  border-bottom: 1px solid #f0f2f5;
  padding: 16px 0;
}

.profile-container .profile-info-container .profile-info,
.user-details h1 {
  color: #2b3352;
  font-size: 16px;
  font-weight: 600;
}

.profile-container .profile-info-container .profile-info,
.user-location {
  font-size: 14px;
  font-weight: 400;
  color: #2b3352;
}
.profile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 0;
}

.profile-header .btn {
  background: hsla(227, 100%, 46%, 1);
  color: #fff;
}

.profile-info-container .phone-info {
  gap: 12px;
  padding: 24px 0;
  justify-content: space-between;
  border-bottom: 1px solid #f0f2f5;
}

.profile-info-container .phone-info,
.phone-number {
  font-weight: 500;
  font-size: 14px;
}

/*============  STATS ============= */

.profile-overview > h2 {
  margin-bottom: 20px;
  font-size: 28px;
  font-weight: 700;
}
.stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  justify-content: space-between;
}

.stats .main-stats {
  background: #fff;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left !important;
  padding: 32px 22px;
  border-radius: 16px;
  border: 1px solid hsla(210, 5%, 92%, 1);
  /* box-shadow: 0px 1px 2px hsla(218, 29%, 5%, 0.05); */
}

.stats h4 {
  font-size: 14px;
  color: hsla(226, 15%, 39%, 1);
}

.stats div {
  font-size: 30px;
  color: hsla(228, 31%, 25%, 1);
  font-weight: 600;
}

.main-stats {
  display: flex;
  flex-direction: column;
}

/*============  CHARTS ============= */
.chart-container {
  width: 100%;
  margin: 40px auto;
}
.chart-container .title {
  font-size: 18px;
  color: #4a4a4a;
  margin-bottom: 20px;
}

.input-wrapper {
  position: relative;
  display: flex;
}

input,
select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;
  color: #111827;
  background: #ffffff;
}

input:focus,
select:focus {
  outline: none;
}
/* CALENDAR */
.calendar-section {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: white;
}

.profile {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile p {
  margin: 2px 0;
}

.calendar {
  text-align: center;
  margin-top: 10px;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  gap: 5px;
  margin-top: 5px;
}

.calendar-grid span {
  padding: 5px;
}

.today {
  font-weight: bold;
  color: blue;
  border-bottom: 2px solid blue;
}

/* VENDOR'S PROFILE */
.plumber-profile-card {
  padding: 1rem 1rem 1rem 2.5rem;
  border-left: 2px solid hsla(214, 14%, 90%, 1);
  width: 35%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.plumber-profile-card__image {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 0.5rem;
}
.plumber-profile-card__name {
  font-size: 1.125rem;
  font-weight: 600;
}
.plumber-profile-card__status-dot {
  color: hsla(152, 82%, 39%, 1);
  margin-left: 0.25rem;
}
.plumber-profile-card__title {
  font-size: 0.875rem;
  color: #555;
}
.plumber-profile-card__toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem 0;
}
.plumber-profile-card__switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}
.plumber-profile-card__switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.plumber-profile-card__slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}
.plumber-profile-card__slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
.plumber-profile-card__switch input:checked + .plumber-profile-card__slider {
  background-color: hsla(227, 84%, 55%, 1);
}
.plumber-profile-card__switch
  input:checked
  + .plumber-profile-card__slider:before {
  transform: translateX(20px);
}
.plumber-profile-card__toggle-label {
  font-size: 0.875rem;
}
.plumber-profile-card__stats {
  display: flex;
  justify-content: space-between;
  text-align: center;
  color: #333;
}
.plumber-profile-card__stat-item {
  flex: 1;
}
.plumber-profile-card__value {
  font-weight: bold;
}
.plumber-profile-card__label {
  font-size: 0.75rem;
  color: #777;
}
.plumber-profile-card__star {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}
.plumber-profile-card__star-icon {
  color: gold;
}

@media (max-width: 1024px) {
  .profile-container {
    flex-direction: column;
    margin-top: 24px;
    margin-left: 25px;
    gap: 20px !important;
    padding: 0 10px;
  }
  .plumber-profile-card {
    background: #fff;
    border-left: none;
    border-radius: 8px;
  }

  .profile-container .profile-overview,
  .plumber-profile-card {
    width: 100%;
  }
}

@media (max-width: 500px) {
  .stats {
    grid-template-columns: 1fr;
    width: 100%;
  }

  .profile-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .profile-header h2 {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .plumber-profile-card {
    padding: 2rem 1rem;
  }

  .profile-container {
    margin-left: 0;
  }

  .header-btn {
    width: 100%;
    justify-content: space-between;
  }
  .header-btn .btn,
  .header-btn .btn-secondary {
    width: 50%;
  }
}
</style>
